import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconMonopolio from '../build/icon-monopolio'

export const IconMonopolio: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconMonopolio} />
}

export default IconMonopolio
